function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Input, Drawer } from 'antd';
var Search = Input.Search;
import { Link } from 'react-router-dom';
import Common from "../components/includes/Common";
import NewEventBox from "../components/NewEventBox";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var Welcome = function Welcome() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEventBoxVisible = _useState2[0],
    setIsEventBoxVisible = _useState2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "page-container",
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsxs("div", {
              className: "wel-box wel-top-box-1",
              style: {
                background: '#FFFFFF'
              },
              children: [/*#__PURE__*/_jsxs("h3", {
                children: ["Bienvenue, ", Common.currentUser != 'undefined' && Common.currentUser.firstname]
              }), /*#__PURE__*/_jsx("p", {
                children: "Votre num\xE9ro mobile \xE0 \xE9t\xE9 confirm\xE9 avec succ\xE8s. Un nouveau monde d'\xE9venements s'ouvre \xE0 vous !"
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsxs("div", {
              className: "wel-box white-bold",
              style: {
                background: '#FE496C'
              },
              children: [/*#__PURE__*/_jsx("h3", {
                className: "white-bold",
                children: "Annoncer votre premier Ev\xE8nement!"
              }), /*#__PURE__*/_jsx("span", {
                className: "highlight",
                children: "#Promoteurs"
              }), /*#__PURE__*/_jsxs("p", {
                children: ["En un deux \xE9tapes: cr\xE9ez votre structure, annoncez votre \xE9venements et commencez \xE0 valider vos tickets. ", /*#__PURE__*/_jsx("b", {
                  children: "HelloTicket"
                }), " est Simple et \xE9fficace."]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  textAlign: "center",
                  padding: "20px"
                },
                children: /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  onClick: function onClick() {
                    setIsEventBoxVisible(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "ANNONCER UN EVENEMENT"
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsxs("div", {
              className: "wel-box white-bold",
              style: {
                background: '#5FCF85'
              },
              children: [/*#__PURE__*/_jsx("h3", {
                className: "white-bold",
                children: "Trouvez vos Ev\xE8nements"
              }), /*#__PURE__*/_jsx("span", {
                className: "highlight",
                children: "#Participez"
              }), /*#__PURE__*/_jsx("p", {
                children: "Vous voulez participer \xE0 un match? Un concert ? ... Trouvez parmis les \xE9venements disponibles, payez votre ticket et acc\xE9dez en toute libert\xE9."
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  textAlign: "center",
                  padding: "20px"
                },
                children: /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  children: /*#__PURE__*/_jsx(Link, {
                    to: "/home/events",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "VOIR LES EVENEMENTS"
                    })
                  })
                })
              })]
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isEventBoxVisible,
      onClose: function onClose() {
        setIsEventBoxVisible(false);
      },
      width: "98%",
      footer: null,
      title: /*#__PURE__*/_jsx("b", {
        children: "ANNONCER UN EVENEMENT"
      }),
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 6,
            children: /*#__PURE__*/_jsx(NewEventBox, {})
          })
        })
      })
    })]
  });
};
export default Welcome;